import ConfigParameter, { gettext } from "../ConfigParameter";

export default class TextContent extends ConfigParameter {

    constructor() {
        super('html', 'textarea',  gettext('Html code'), 'mainConfig', '');
    }

}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/HtmlContent.js